module.exports = __webpack_public_path__ + "img/envelope9.c44daa07.jpg";